// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15Z0a","top":"styles_top__2ubDe","left":"styles_left__jlOgb","description":"styles_description__2s0AV"};